// extracted by mini-css-extract-plugin
module.exports = {"partnerContainer":"Partners-module--partnerContainer--1jGBH","image":"Partners-module--image--29SsO","partner":"Partners-module--partner--2AKB3"};